<template>
  <el-card v-loading="loading" class="pro-detail">
    <!-- 基本信息 -->
    <el-alert class="info-title" title="基本信息" type="info" :closable="false">
      <!-- <el-button v-on:click="exportDeclareMessage">导出申报报文</el-button> -->
      <el-button v-hp v-on:click="reWms()">重推仓库</el-button>
      <el-button
        v-hp
        v-if="this.declareDetailInfo.ccbBizState !== '800'"
        v-on:click="updateBusinessState()"
        >手动放行
      </el-button>
    </el-alert>
    <el-row class="info">
      <el-form label-width="80" :inline="true">
        <el-row>
          <!--                    <el-col :span="8">-->
          <!--                        <el-form-item label="主订单号:">-->
          <!--                            {{ declareDetailInfo.tradeOrderId }}-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :span="8">
            <el-form-item label="商户订单号:">
              {{ declareDetailInfo.tradeOrderId }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出库单号:">
              {{ declareDetailInfo.packageBizId }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申报企业名称:">
              {{ declareDetailInfo.declareEnterprise.enterpriseCustomsName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电商平台名称:">
              {{ declareDetailInfo.ePlatformEnterprise.enterpriseCustomsName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电商企业名称:">
              {{ declareDetailInfo.eEnterprise.enterpriseCustomsName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跨境模式:">
              {{ declareDetailInfo.crossType }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申报口岸:">
              {{ declareDetailInfo.portNidDesc }}
              <!--                            <el-button size="mini" type="primary">更换申报口岸</el-button>-->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单总金额:">
              {{ declareDetailInfo.paymentInfo.goodsTotalAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券金额:">
              {{ declareDetailInfo.paymentInfo.discountAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总税金:">
              {{ declareDetailInfo.paymentInfo.taxAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付金额:">
              {{ declareDetailInfo.paymentInfo.tradeAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单支付时间:">
              {{ declareDetailInfo.gmtMerchantPaid }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="下单时间:">
              {{ declareDetailInfo.gmtMerchantCreate }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="清单申报时间:">
              {{ declareDetailInfo.ccbDeclareGmtPass }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="清单申报状态:">
              {{
                declareDetailInfo.ccbBizState == null
                  ? "未回执"
                  : parseInt(declareDetailInfo.ccbBizState) <= 0
                  ? "异常"
                  : declareDetailInfo.ccbBizRemark
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 订购人信息 -->
    <el-alert
      v-if="false"
      class="info-title"
      title="2：订购人信息"
      type="info"
      :closable="false"
    >
    </el-alert>
    <el-row class="info" v-if="false">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="8">
            <el-form-item label="订购人姓名:">
              <el-input v-model="declareDetailInfo.payerInfo.payerName" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="订购人身份证号码:">
              <el-input v-model="declareDetailInfo.payerInfo.payerIdNumber" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button v-hp @click="updatePayerInfo()" type="primary"
                >编缉</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 收货人信息 -->
    <el-alert
      class="info-title"
      title="3：收货人信息"
      type="info"
      :closable="false"
      v-if="false"
    >
    </el-alert>
    <el-row class="info" v-if="false">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="收货人姓名:">
              <el-input
                v-model="declareDetailInfo.consigneeInfo.consigneeName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人人身份证号码:">
              <el-input v-model="declareDetailInfo.consigneeInfo.idNumber" />
            </el-form-item>
          </el-col>
          <el-col class="address" :span="16">
            <el-form-item label="收货地址:">
              <el-input
                v-model="declareDetailInfo.consigneeInfo.addrProvince"
              />
              <el-input v-model="declareDetailInfo.consigneeInfo.addrCity" />
              <el-input
                v-model="declareDetailInfo.consigneeInfo.addrDistrict"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详细地址:">
              <el-input
                label-width="500px"
                type="textarea"
                v-model="declareDetailInfo.consigneeInfo.addrDetail"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮编">
              <el-input v-model="declareDetailInfo.consigneeInfo.zipCode" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button v-hp @click="updateConsigneeInfo()" type="primary"
                >编辑</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 支付信息 -->
    <el-alert
      class="info-title"
      title="支付信息"
      type="info"
      :closable="false"
      v-if="false"
    >
    </el-alert>
    <el-row class="info" v-if="false">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="6">
            <el-form-item label="支付方式:">
              {{ declareDetailInfo.paymentInfo.payTypeDesc }}
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="支付金额:">
              {{ declareDetailInfo.paymentInfo.tradeAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付时间:">
              {{ declareDetailInfo.gmtMerchantPaid }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付流水号:">
              {{ declareDetailInfo.paymentInfo.payNo }}
            </el-form-item>
          </el-col>
          <!--                    <el-col :span="1">-->
          <!--                        <el-form-item>-->
          <!--                            <el-button type="primary">编辑</el-button>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
        </el-row>
      </el-form>
    </el-row>

    <!-- 仓储信息 -->
    <el-alert class="info-title" title="仓储信息" type="info" :closable="false">
    </el-alert>
    <el-row class="info">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货仓:">
              {{ declareDetailInfo.warehouseCodeDesc }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流承运商:">
              {{ declareDetailInfo.carrierCodeDesc }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="快递单号:">
              {{ declareDetailInfo.mailNo }}
            </el-form-item>
          </el-col>
          <!--                    <el-col :span="1">-->
          <!--                        <el-form-item>-->
          <!--                            <el-button size="mini" type="primary">编辑</el-button>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
        </el-row>
      </el-form>
    </el-row>

    <!-- 商品信息 -->
    <el-alert class="info-title" title="商品信息" type="info" :closable="false">
    </el-alert>
    <el-row class="info">
      <element-table
        headerClassName="stock-table"
        :data="declareDetailInfo.items"
        :columns="skuListColumns"
        :loading="loading"
        border
      ></element-table>
    </el-row>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";

export default {
  data() {
    return {
      bizId: this.$route.params.id,
      loading: false,
      skuListColumns: [
        {
          title: "渠道商户商品编号",
          key: "merchantGoodsNo",
          minWidth: 150,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.merchantGoodsNo} />;
          },
        },
        {
          title: "商品料号",
          key: "goodsItemNo",
          minWidth: 160,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.goodsItemNo} />;
          },
        },
        {
          title: "金二帐册序号",
          key: "itemRecordNo",
          minWidth: 160,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.itemRecordNo} />;
          },
        },
        {
          title: "商品名称",
          key: "goodsName",
          minWidth: 160,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.goodsName} />;
          },
        },
        {
          title: "备案商品名称",
          key: "goodsDeclareName",
          minWidth: 160,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.goodsDeclareName} />;
          },
        },
        {
          title: "商品条码",
          key: "barcode",
          minWidth: 130,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.barcode} />;
          },
        },
        {
          title: "批次号",
          key: "batchNo",
          minWidth: 100,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.batchNo} />;
          },
        },
        {
          title: "hs编码",
          key: "hsCode",
          minWidth: 100,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.hsCode} />;
          },
        },
        {
          title: "净重",
          key: "netWeight",
          minWidth: 100,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.netWeight} />;
          },
        },
        {
          title: "原产国编码",
          key: "originCountryCode",
          minWidth: 120,
          align: "center",
          render(h, param) {
            let row = param.row;
            return <el-input v-model={row.originCountryCode} />;
          },
        },
        {
          title: "第一单位数量",
          key: "firstCount",
          width: 120,
          align: "center",
        },
        {
          title: "第一单位",
          key: "firstUnitCode",
          width: 100,
          align: "center",
        },
        {
          title: "第二单位数量",
          key: "secondCount",
          width: 120,
          align: "center",
        },
        {
          title: "第二单位",
          key: "secondUnitCode",
          width: 100,
          align: "center",
        },
        {
          title: "数量",
          key: "quantity",
          width: 100,
          align: "center",
        },
        {
          title: "计量单位",
          key: "unitCode",
          minWidth: 100,
          align: "center",
        },

        {
          title: "单价",
          key: "unitAmount",
          width: 100,
          align: "center",
        },
        {
          title: "折扣金额",
          key: "discountAmount",
          width: 100,
          align: "center",
        },
        {
          title: "总价",
          key: "actualAmount",
          width: 100,
          align: "center",
        },
        {
          title: "税金",
          key: "taxAmount",
          width: 100,
          align: "center",
        },
        {
          title: "操作",
          key: "totalPrice",
          width: 100,
          align: "center",
          render: (h, param) => {
            return (
              <el-button
                onClick={this.updateStcokoutOrderSku.bind(this, param.row)}
                type="text"
              >
                编缉
              </el-button>
            );
          },
        },
      ],
      declareDetailInfo: {
        eEnterprise: {},
        ePlatformEnterprise: {},
        declareEnterprise: {},
        paymentInfo: {},
        payerInfo: {},
        consigneeInfo: {},
        ccbBizState: undefined,
      },
      region: {
        provinces: [],
        cities: [],
        areas: [],
      },
    };
  },
  components: {
    ElementTable,
  },
  watch: {
    $route(to, from) {
      if (to.name === "declareDetail") {
        this.bizId = this.$route.params.id;
        this.fetch();
      }
    },
  },
  created() {
    this.bizId = this.$route.params.id;
    this.fetch();
  },
  mounted() {
    this.bizId = this.$route.params.id;
  },
  methods: {
    // 获取入库单详情
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("declareDetail", {
          bizId: this.bizId,
        })
        .then((res) => {
          this.declareDetailInfo = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reWms(bizId) {
      this.loading = true;
      this.$confirm("请确定是否重推wms？", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then(() => {
          this.$store
            .dispatch("reWms", {
              bizId: this.bizId,
            })
            .then((res) => {
              this.loading = false;
              if (res.isSuccess) {
                this.$message.success("成功");
              } else {
                this.$message.error(res.resultMessage || "重推wms失败");
              }
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    updateBusinessState() {
      let __this = this;

      this.$prompt("请确认清单编号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: __this.declareDetailInfo.invtNo,
      })
        .then(({ value }) => {
          if (!value) {
            this.$message.error("请输入清单编号");
            return;
          }
          __this.loading = true;
          __this.$store
            .dispatch("updateBusinessState", {
              request: JSON.stringify({
                portBillId: __this.declareDetailInfo.portBillId,
                currentPortBillBusinessState:
                  __this.declareDetailInfo.ccbBizState,
                portBillBusinessState: "800",
                customsBizId: value,
              }),
            })
            .then((res) => {
              __this.loading = false;
              if (res.isSuccess) {
                __this.fetch();
                this.$message.success("手动执为放行状态成功");
              } else {
                this.$message.error(res.resultMessage || "设置为放行状态失败");
              }
            })
            .catch((error) => {
              __this.loading = false;
              console.log(error);
              this.$message.error(error.msg || "服务器错误");
            });
        })
        .catch(() => {
          this.$message.warning("已取消");
        });
    },
    updatePayerInfo() {
      this.$confirm("确定修改订购人信息", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.updateStockoutOrderInfo({
            payerName: this.declareDetailInfo.payerInfo.payerName,
            payerIdNumber: this.declareDetailInfo.payerInfo.payerIdNumber,
          });
        })
        .catch(() => {});
    },
    //修改收货人信息
    updateConsigneeInfo() {
      this.$confirm("确定修改收货人信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.updateStockoutOrderInfo({
            buyerName: this.declareDetailInfo.consigneeInfo.consigneeName,
            idNumber: this.declareDetailInfo.consigneeInfo.idNumber,
            buyerZipcode: this.declareDetailInfo.consigneeInfo.zipCode,
            buyerAddress: this.declareDetailInfo.consigneeInfo.addrDetail,
            buyerDistrict: this.declareDetailInfo.consigneeInfo.addrDistrict,
            buyerCity: this.declareDetailInfo.consigneeInfo.addrCity,
            buyerProvince: this.declareDetailInfo.consigneeInfo.addrProvince,
          });
        })
        .catch(() => {});
    },
    updateStockoutOrderInfo(data) {
      this.loading = true;
      this.$store
        .dispatch("updateStockoutOrderInfo", {
          request: JSON.stringify({
            bizId: this.declareDetailInfo.packageBizId,
            ...data,
          }),
        })
        .then((res) => {
          if (res.value) {
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("服务器错误");
        });
    },
    exportDeclareMessage() {
      if (this.declareDetailInfo.requestMessage == null) {
        this.$message.info("暂无可下载报文");
        return;
      }
      let a = document.createElement("a");
      a.download = "申报报文.txt"; //requetMessage
      let blob = new Blob([this.declareDetailInfo.requestMessage]);
      a.href = URL.createObjectURL(blob);
      a.click();
    },
    updateStcokoutOrderSku(goodsItem) {
      this.$confirm("确定修改商品信息", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.loading = true;
          this.$store
            .dispatch("updateStcokoutOrderSku", {
              request: JSON.stringify(goodsItem),
            })
            .then((res) => {
              if (res.isSuccess) {
                this.$message.success("修改成功");
              } else {
                this.$message.error("修改失败");
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
              this.$message.error("服务器错误");
            });
        })
        .catch(() => {});
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
  }

  .info {
    padding: 10px 20px 30px;

    .address {
      white-space: nowrap;

      .el-input {
        width: 33% !important;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}
</style>
